<iframe class="iframe-comp-mobile iframe-comp" *ngIf="iframeSafeUrl" [src]="iframeSafeUrl"></iframe>